export const formatBytes = (byteCount: number | null | undefined): string => {
  if (byteCount) {
    if (byteCount < 1024) {
      return `${byteCount} б`;
    } else if (byteCount < Math.pow(1024, 2)) {
      return `${(byteCount / 1024).toFixed(1)} Кб`;
    } else if (byteCount < Math.pow(1024, 3)) {
      return `${(byteCount / Math.pow(1024, 2)).toFixed(1)} Мб`;
    } else if (byteCount < Math.pow(1024, 4)) {
      return `${(byteCount / Math.pow(1024, 3)).toFixed(1)} Гб`;
    } else {
      return `${(byteCount / Math.pow(1024, 4)).toFixed(1)} Тб`;
    }
  } else {
    return '0 б';
  }
};
